/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CommunicationChannelsData, UpdateSettingsCommunicationChannelsApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSettingsCommunicationChannels: build.mutation<
      CommunicationChannelsData,
      UpdateSettingsCommunicationChannelsApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/settings/communication-channels`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateSettingsCommunicationChannelsApi };
export const { useUpdateSettingsCommunicationChannelsMutation } = injectedRtkApi;
